module.exports = {"id":"160004","name":"Mijhael Echeberria","rating":"72","photo":"./data/images/photos/3/160004.png","club":{"name":"Unión Española","logo":"./data/images/clubs/UnionEspanola.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MijhaelEcheberria0.json
// module id = 3017
// module chunks = 0